import { forwardRef } from 'react'
import { SimpleTextField } from '@components/ui/TextField'

import { Controller } from 'react-hook-form'

// @ts-ignore
import ReactPhoneInput from 'react-phone-number-input/input'

const PhoneInput = (props: any, ref: any) => {
  const { control, defaultValue = '', helperText = null, name } = props || {}
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <ReactPhoneInput
          ref={ref}
          country="NC"
          inputComponent={SimpleTextField}
          {...props}
          value={value}
          onChange={newValue => onChange(newValue ?? '')} // check to send empty string when empty
          error={!!error}
          helperText={error ? error.message : helperText}
        />
      )}
    />
  )
}

export default forwardRef(PhoneInput)
